import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import DashboardCharts from "./DashboardCharts";

const Widgets = ({
    totalClients,
    totalUsers,
    totalClientAdmin,
    totalClientUsers,
    totalClientAuditors,
    totalCertifications,
}) => {

    const referenceTotal = 100;

    const jobWidgets = [
        {
            id: 1,
            lable: "TOTAL CLIENTS",
            jobs: totalClients,
            series: [Math.trunc((totalClients / referenceTotal) * 100)],
            color: "#09b39b",
        },
        {
            id: 2,
            lable: "TOTAL USERS",
            jobs: totalUsers,
            series: [Math.trunc((totalUsers / referenceTotal) * 100)],
            color: "#09b39b",
        },
        {
            id: 3,
            lable: "CLIENT ADMIN",
            jobs: totalClientAdmin,
            series: [Math.trunc((totalClientAdmin / referenceTotal) * 100)],
            color: "#09b39b",
        },
        {
            id: 4,
            lable: "CLIENT USERS",
            jobs: totalClientUsers,
            series: [Math.trunc((totalClientUsers / referenceTotal) * 100)],
            color: "#f06548",
        },
        {
            id: 5,
            lable: "CLIENT AUDITORS",
            jobs: totalClientAuditors,
            series: [Math.trunc((totalClientAuditors / referenceTotal) * 100)],
            color: "#09b39b",
        },
        {
            id: 6,
            lable: "TOTAL CERTIFICATIONS",
            jobs: totalCertifications,
            series: [Math.trunc((totalCertifications / referenceTotal) * 100)],
            color: "#f06548",
        },
    ];

    return (
        <>
            <Col lg={12} xl={5} xxl={5} className="ps-1">
                <div className="d-flex flex-column h-100">
                    <Row>
                        {jobWidgets.map((widget, key) => (
                            <Col lg={3} xl={6} xxl={6} key={key} className="pe-1 ps-1">
                                <Card className="card-animate mb-2 overflow-hidden">
                                    <div
                                        className="position-absolute start-0"
                                        style={{ zIndex: "0" }}
                                    >
                                        <svg
                                            version="1.2"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 200 120"
                                            width="200"
                                            height="120"
                                        >
                                            <path
                                                id="Shape 8"
                                                style={{ opacity: ".05", fill: "rgb(11 152 93)" }}
                                                d="m189.5-25.8c0 0 20.1 46.2-26.7 71.4 0 0-60 15.4-62.3 65.3-2.2 49.8-50.6 59.3-57.8 61.5-7.2 2.3-60.8 0-60.8 0l-11.9-199.4z"
                                            />
                                        </svg>
                                    </div>
                                    <CardBody style={{ zIndex: "1", padding: '.5rem' }}>
                                        <div className="d-flex align-items-center">
                                            <div className="flex-grow-1 overflow-hidden">
                                                <p className="text-uppercase fw-medium text-muted mb-3" style={{fontSize: '.7rem'}}>
                                                    {" "}
                                                    {widget.lable}
                                                </p>
                                                <h4 className="fw-semibold ff-secondary mb-0" style={{fontSize: '1rem'}}>
                                                    <span className="counter-value" data-target="36894">
                                                        {widget.jobs}
                                                    </span>
                                                </h4>
                                            </div>
                                            <div className="flex-shrink-0">
                                                <DashboardCharts
                                                    seriesData={widget.series}
                                                    colors={widget.color}
                                                />
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </div>
            </Col>
        </>
    );
};

export default Widgets;